/** @format */
import React from 'react';
import PropTypes from 'prop-types';

const FailingPaymentsIcon = ({ 
  className = "h-7 w-7", 
  failureCount = 0,
  showPinkAccent = false 
}) => {
  return (
    <div className="relative">
      <svg 
        className={className} 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Failing payments alert icon"
      >
        {/* Credit card base */}
        <rect 
          x="6" 
          y="12" 
          width="20" 
          height="12" 
          rx="2" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none"
        />
        
        {/* Card magnetic stripe */}
        <rect 
          x="6" 
          y="15" 
          width="20" 
          height="2" 
          fill="currentColor" 
          opacity="0.5"
        />
        
        {/* Card chip */}
        <rect 
          x="9" 
          y="19" 
          width="3" 
          height="2.5" 
          rx="0.5" 
          fill="currentColor" 
          opacity="0.6"
        />
        
        {/* Card numbers (dots) */}
        <g opacity="0.4">
          <circle cx="15" cy="20" r="0.5" fill="currentColor" />
          <circle cx="17" cy="20" r="0.5" fill="currentColor" />
          <circle cx="19" cy="20" r="0.5" fill="currentColor" />
          <circle cx="21" cy="20" r="0.5" fill="currentColor" />
        </g>
        
        {/* Warning/alert symbol above card */}
        <g transform="translate(16, 8)">
          <path
            d="M-3 0 L0 -6 L3 0 Z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
            strokeLinejoin="round"
          />
          <path
            d="M0 -4.5 L0 -2.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle
            cx="0"
            cy="-1.5"
            r="0.3"
            fill="currentColor"
          />
        </g>
      </svg>
      
      {/* Pink alert indicator - conditional based on failure count or accent flag */}
      {(showPinkAccent || failureCount > 0) && (
        <div className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-primary rounded-full border-2 border-white">
        </div>
      )}
    </div>
  );
};

FailingPaymentsIcon.propTypes = {
  className: PropTypes.string,
  failureCount: PropTypes.number,
  showPinkAccent: PropTypes.bool,
};

export default FailingPaymentsIcon;